import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import { Text } from '@/components/ui/text'
import { TableCoversFilterKey } from '@/redux/slices/tableCoverSlice'
import { useTranslation } from 'react-i18next'
import { Image } from 'react-native'

type TableCoverListFooterProps = {
  empty: boolean
  loading: boolean
  context?: TableCoversFilterKey | 'search'
}

export default function TableCoverListFooter({ empty, loading, context }: TableCoverListFooterProps) {
  const { t } = useTranslation('covers')

  if (loading) {
    return (
      <Center className="h-[20vh]">
        <Spinner className="mb-2" />
      </Center>
    )
  }

  if (empty) {
    return (
      <Center className="h-[60vh]">
        <Image source={require('@/assets/images/no_result.png')} style={{ width: 200, height: 200, marginBottom: 16 }} resizeMode="contain" />
        <Text className="text-typography-500 text-center px-6">
          {t('empty_tables', { context: context === TableCoversFilterKey.MyTables ? undefined : context })}
        </Text>
      </Center>
    )
  }
}
